import { Button, Container, Group, Stack, Text, Title } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import classes from './no-permission.module.css'

export default function NoPermission() {
  return (
    <Container className={classes.root}>
      <Stack justify="center">
        <div className={classes.label}>403</div>
        <Title className={classes.title}>ไม่สามารถแสดงผลให้คุณได้</Title>
        <Text c="dimmed" size="lg" className={classes.description}>
          คุณไม่ได้รับสิทธิ์ในการเข้าถึงหน้านี้
          อาจเป็นเพราะว่าคุณอยู่คนละหน่วยงาน หรือ
          ระดับตำแหน่งงานของคุณยังไม่ได้รับอนุญาต
          <br /> กรุณาติดต่อผู้ดูแลระบบ เพื่อเพิ่มสิทธิ์ให้คุณ
        </Text>
        <Group justify="center">
          <Link to="/home">
            <Button variant="subtle" size="md">
              กลับสู่หน้าหลัก
            </Button>
          </Link>
        </Group>
      </Stack>
    </Container>
  )
}
